import {intlShape, utils} from '@wallaby-ui/core';
import PropTypes from 'prop-types';
import * as React from 'react';
import {injectIntl} from 'react-intl';

import DatePicker from './DatePicker';
import {ContentProperty} from 'src/js/model/auto_layout_content_schema';
import {LayoutProperty} from 'src/js/model/auto_layout_layout_schema';
import {MetadataSchema} from 'src/js/model/auto_layout_metadata_schema';

const MonthPicker = ({intl, ...rest}) => {
  const locale = utils.DateUtils.translateLocaleToDateFnsLocale(intl.locale);
  return (
    <DatePicker
      {...rest}
      dateFormat={utils.DateUtils.MONTH_FORMAT}
      locale={locale}
      showMonthYearPicker
    />
  );
};

MonthPicker.displayName = 'MonthPicker';

MonthPicker.propTypes = {
  content: PropTypes.instanceOf(ContentProperty).isRequired,
  layout: PropTypes.instanceOf(LayoutProperty).isRequired,
  metadata: PropTypes.instanceOf(MetadataSchema).isRequired,
  screenId: PropTypes.string.isRequired,
  idSuffix: PropTypes.string,
  data: PropTypes.objectOf(PropTypes.any),
  pathToData: PropTypes.string,
  intl: intlShape.isRequired,
  isReadOnly: PropTypes.bool,
  isTextOnly: PropTypes.bool,
  inputName: PropTypes.string,
  label: PropTypes.string,
  expanded: PropTypes.bool,
  onDataChange: PropTypes.func.isRequired,
};

MonthPicker.defaultProps = {
  data: {},
  idSuffix: '',
  pathToData: '',
  isReadOnly: false,
  isTextOnly: false,
  inputName: '',
  label: '',
  expanded: false,
};

export default injectIntl(MonthPicker);
